import React from "react";
import "./Confirm_Modal.css";
import { Modal, Button } from "react-bootstrap";
import Exlamentry_lottie from "../../../../Animation/Exlamentry_lottie/Exlamentry_lottie";
import { useNavigate } from "react-router-dom";

function Confirm_Modal({ ...props }) {
  const navigate = useNavigate();
  return (
    <Modal
      {...props}
      centered
      size="sm"
      backdrop="static"
      className="Commission_Receive_modal Common_modal"
    >
      <Modal.Body>
        <div className="Commission_Receive">
          <div className="content_holder">
            <div className="done_lottie_holder">
              <Exlamentry_lottie />
            </div>
            <h5>Do you want to log out?</h5>
          </div>

          <div className="upi_button_wrapper">
            <Button
              className="btn_register_bg mb-3"
              onClick={() => navigate("/login")}
            >
              Confirm
            </Button>

            <Button className="btn-register" onClick={props.onHide}>
              Cancel
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default Confirm_Modal;
